import React from "react";
import styled from "styled-components";
import Modal from "../../../../components/Modal";
import { Typography, Grid } from "@mui/material";
import * as Yup from "yup";
import { Form, FormikProvider, useFormik } from "formik";
import FormTextField from "../../../../components/FormTextField";

const MainContainer = styled.div`
  padding-bottom: 40px;
  min-height: 100px;
  .numberField {
    margin-top: 20px;
  }
  .responseContainer {
    margin-top: 12px;
    .listItem {
      display: flex;
      flex-direction: row;
      margin-left: 10px;
    }
  }
`;

const AddEditorModal = ({
  onSubmit,
  onCancel,
  isEditMode,
  isLoading,
  editorData,
}) => {
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .trim()
      .required("Required")
      .matches(/^[a-zA-Z_ ]*$/, "Only Characters Allowed"),
    mobileNumber: Yup.string()
      .min(10, "Min 10 characters")
      .max(10, "Max 10 characters")
      .required("Required")
      .matches(phoneRegExp, "Invalid Number"),
    email: Yup.string().trim().required("Required").email("Invalid Email"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: isEditMode ? editorData?.name : "",
      mobileNumber: isEditMode ? editorData?.mobile_no : "",
      email: isEditMode ? editorData?.email_id : "",
    },
    validationSchema: validationSchema,
    validateOnBlur: false,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  return (
    <Modal
      onSubmit={() => formik.submitForm()}
      confirmTitle={"Submit"}
      cancelTitle={"Cancel"}
      onCancel={onCancel}
      isLoading={isLoading}
      width={"50%"}
      isDisabled={!formik.dirty || !formik.isValid}
    >
      <MainContainer>
        <Typography
          variant="h6"
          textAlign={"center"}
          fontWeight={700}
          width={"100%"}
          marginBottom={2}
        >
          {isEditMode ? "Edit Editor Details" : "Add Editor"}
        </Typography>
        <FormikProvider value={formik}>
          <Form>
            <Grid container spacing={4}>
              {/* <Grid item xs={6}>
                <FormTextField
                  name="fid"
                  label="User Id"
                  required
                  disabled={isEditMode}
                  placeholder={"Enter User Id"}
                />
              </Grid> */}
              <Grid item xs={6}>
                <FormTextField
                  name="name"
                  label="Name"
                  required
                  placeholder={"Enter Name"}
                />
              </Grid>
              <Grid item xs={6}>
                <FormTextField
                  name="mobileNumber"
                  label="Mobile Number"
                  required
                  placeholder={"Enter Mobile Number"}
                />
              </Grid>
              <Grid item xs={6}>
                <FormTextField
                  name="email"
                  label="Email"
                  required
                  placeholder={"Enter Email Id"}
                />
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </MainContainer>
    </Modal>
  );
};

export default AddEditorModal;
